/**
 * Booster, simulateur d'entraînement des managers (spec/booster-routage-code-contextes-sideband.md
 * § 2 bis, plan docs/plans/booster-creation-simulatorid.md).
 *
 * Les workflows N8N des managers routent sur `simulators.id` : Booster a donc le MÊME identifiant
 * sur les quatre environnements, posé par la migration `20261019-1606_creer_simulateur_booster`.
 * Ne jamais le recréer par l'admin.
 */

export const BOOSTER_SIMULATOR_ID = "33cf7b20-b967-4660-bb42-551e3fd54a2c";

/**
 * Simulateurs dont la suppression est refusée (admin ET corbeille) : une restauration rendrait le
 * bon identifiant mais vidé de ses critères, contextes et liens (condition d).
 */
export const SIMULATEURS_NON_SUPPRIMABLES: readonly string[] = [BOOSTER_SIMULATOR_ID];

export function simulateurNonSupprimable(id: string | null | undefined): boolean {
  return !!id && SIMULATEURS_NON_SUPPRIMABLES.includes(id);
}
